var CSSTransition = require("react-transition-group/CSSTransition");
var TransitionGroup = require("react-transition-group/TransitionGroup");

var Glyphicon = require("components/utility/icons/Glyphicon");
var LoadingButton = require("components/utility/LoadingButton");
var CoinDisplay = require("components/utility/CoinDisplay");
var Tiers = require("lib/games/Tiers");
var ShopSales = require("lib/games/ShopSales");
var ReactTooltip = require("react-tooltip");
var PurchaseModal = require("components/games/PurchaseModal");


require("avatars/owl_shop_display.scss");

class OwlShopDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = {
			itemOffset: 0
		};
	}

	checkConfirm(value) {
		this.setState({inConfirm: value})
	}

	componentDidUpdate(prevProps) {
		var { beginAtTier, items, previewItem } = this.props
		//rerender beginning with the items at the user's current tier
		if (prevProps.beginAtTier != beginAtTier || prevProps.items != items) {
			this.beginAtTierOffset()
		}
	
		if (this.props.previewItem != undefined && prevProps.previewItem != this.props.previewItem) {
			this.beginAtItemOffset()
		}
	}

	componentDidMount() {
		if ([OwlShopDisplay.BACKGROUND_SOUNDS,OwlShopDisplay.OWL_HOOTS].includes(this.props.itemType)) {
			setTimeout(function() {
				if (window.wrL2eSound) {
	   				window.wrL2eSound.removeSources('shop')
	   			}
   				this.getSoundPerks()
	 		}.bind(this), 100);
		}
		
		if (this.props.beginAtTier) {
			this.beginAtTierOffset()
		}
	}

	// skip to page with items at the user's tier
	beginAtTierOffset() {
		var tierPage = this.getTierPage(this.props.items, this.props.user.tier)
		var tierOffset = tierPage*(OwlShopDisplay.MAX_ITEMS)
		this.setState({ itemOffset: tierOffset })
	}

	// skip to page with item
	beginAtItemOffset() {
		var { previewItem, items } = this.props
		
		if (!previewItem || !items) { return }
		
		var itemIndex = items.findIndex(item => {
			return previewItem.id == item.id
		})
		this.setState({ itemOffset: (Math.floor(itemIndex / OwlShopDisplay.MAX_ITEMS) * (OwlShopDisplay.MAX_ITEMS))})
	}
	
	buildSelectItemF(item) {
		return function(e) {
			$wr.nope(e)
			//Trigger perk sound
			if ([OwlShopDisplay.BACKGROUND_SOUNDS,OwlShopDisplay.OWL_HOOTS].includes(item.perk_type)) {

				if (window.wrL2eSound) {
					window.wrL2eSound.stopAllSounds();
					window.wrL2eSound.playSound(item.name + "_shop" );
				}
			}
			
			this.props.selectItem(item, this.getEquipPatchType());
		}.bind(this)
	}

	getEquipPatchType() {
		return this.props.itemType;
	}

	getAlternatePatchTypes() {
		if (this.props.hideAlternates) return []
		if (_.include(["body", "body2"], this.props.itemType)) {
			return [{ text: "Item 1", value: "body" },
				{ text: "Item 2", value: "body2" }];

		} else if (_.include(["hand", "left_hand", "wings"], this.props.itemType)) {
			return [{ text: "Left", value: "left_hand" },
				{ text: "Right", value: "hand" },
				{ text: "Position", value: "wings" }];
		} else {
			return [];
		}
	}

	getAlternatePerkTypes() {
		if (this.props.hideAlternates) return []
		 if (_.include(["wall_items","wall_items2"], this.props.itemType)) {
			return [{ text: "Item 1", value: "wall_items" },
				{ text: "Item 2", value: "wall_items2" }];
		} else if (_.include(["floor_items","floor_items2"], this.props.itemType)) {
			return [{ text: "Item 1", value: "floor_items" },
				{ text: "Item 2", value: "floor_items2" }];
		} else {
			return [];
		}
	}

	buildOnClickAlternateF(patchType) {
		return function(e) {
			$wr.nope(e)
			this.props.buildItemTypeSelectF(patchType)();
		}.bind(this)
	}
	buildOnClickAlternateFPerk(perkType) {
		return function(e) {
			e.preventDefault();
			this.props.buildItemTypeSelectF(null,perkType)();
		}.bind(this)
	}

	onPurchase() {
		this.props.purchaseItem(this.props.previewItem, this.getEquipPatchType());
		this.refs.purchaseModal.hide()
	}

	confirmPurchase() {
		this.refs.purchaseModal.show()
	}
	

	previewAnimation(name) {
		this.props.previewAnimation(name)
	}

	onRemove() {
		this.props.removeItem(this.props.previewItem, this.getEquipPatchType());
	}

	canShiftLeft() {
		return this.state.itemOffset > 0;
	}

	canShiftRight() {
		return this.state.itemOffset + OwlShopDisplay.MAX_ITEMS < this.props.items.length;
	}

	shiftLeft() {
		if (this.canShiftLeft()) {
			this.setState({ itemOffset: this.state.itemOffset - OwlShopDisplay.MAX_ITEMS })			
		}
	}

	shiftRight() {
		if (this.canShiftRight()) {
			this.setState({ itemOffset: this.state.itemOffset + OwlShopDisplay.MAX_ITEMS })			
		}
	}

	renderPatchItem(patch) {
		var patchPath = "patches/" + patch["origin_patch_type"]
			+ "/" + patch["name"] + "-s.png";
		patchPath = dynamicRequire(patchPath);

		if (patch == this.props.previewItem) {
			var selectedClass = "selectedPatch "
		}

		if (this.props.user.tier + 2 <= patch.tier) {
			var displayItemClass = " outRangeTier"
			var src = require("tiers/lock.png");
			var lockTip = "You must be level " + (patch.tier + 1) + " to buy this item.";
			var patchImg = (
				<img src={ src } className="lockImg" data-tip={ lockTip } />
			);
		} else if (this.props.user.tier + 1 <= patch.tier) {
			var displayItemClass = " inRangeTier"
			var lockTip = "You must be level " + (patch.tier + 1) + " to buy this item.";
			var patchImg = (
				<img src={ patchPath } className="patchThumbnail" data-tip={ lockTip } />
			);
		} else {
			var displayItemClass = " sameTier"
			var patchImg = (
				<img src={ patchPath } className="patchThumbnail" />
			);
		}

		if (this.state.inConfirm) {
			displayItemClass += " inConfirm"
		}

		if (this.props.mode != "dressing") {
			if (!patch.owned) {
				if (this.props.user.tier + 2 <= patch.tier) {
					var purchase = "";
				} else {
					var purchase = (
						<CoinDisplay coins={ patch.price } height={ 20 } />
					);
				}
			} else {
				if (patch.has_animation) {
					var purchase = (
						<span className="statusText">
							<Glyphicon icon="flash" /> upgraded
						</span>
					)
				} else {
					var purchase = (
						<span className="statusText">
							<Glyphicon icon="ok" /> owned
						</span>
					)
				}
				
			}
		}


		// don't display tier indicators on special items
		if (patch.source != "special") {
			var tier = (<img src={ Tiers.getIcon(patch.tier) } className="tierImg" />)
		}

		var patchValueContainer = (
			<div className="patchValueContainer">
				{ purchase }			
				{ tier }
			</div>
		)

		return (
			<a key={ patchPath } className={ "displayItem " + selectedClass + displayItemClass} 
				href="#" onClick={ this.buildSelectItemF(patch) }>
				{ patchImg }
				<p className="title">{ patch.title }</p>
				{ patchValueContainer }
			</a>
		);
	}

	renderPerkItem(perk) {
		if (perk.perk_type == OwlShopDisplay.BACKGROUNDS || perk.perk_type == OwlShopDisplay.HOUSES
			 || perk.perk_type == OwlShopDisplay.OWL_HOOTS || perk.perk_type == OwlShopDisplay.BACKGROUND_SOUNDS 
			 || perk.perk_type == OwlShopDisplay.GREETINGS ) {
			
			if (perk.perk_type == OwlShopDisplay.HOUSES || OwlShopDisplay.FURNITURES.indexOf(perk.perk_type) >= 0) {
				var name = perk["name"].toLowerCase().replace(/\s/g, "-");
				if (name.indexOf('\'') >= 0) {
					name = name.replace('\'', "");
				}
			} else {
				var name = perk["name"].toLowerCase().replace(/\s/g, "_")
			}
			var perkPath = "perks/" + perk["origin_perk_type"]
				+ "/" + name + ".png";
			perkPath = dynamicRequire(perkPath);
			var perkKey = perkPath;
			var perkTitle = perk["name"]

		} else if (OwlShopDisplay.FURNITURES.indexOf(perk.perk_type) >= 0) {
			var perkPath = "perks/" + perk["origin_perk_type"]
				+ "/" + perk["name"] + ".png";
			perkPath = dynamicRequire(perkPath);
			var perkKey = perkPath;
			var perkTitle = perk["title"]
		} else {
			var perkTitle = perk["name"]
		}

		var tier = (
			<span className="tierDisplay">{ perk.tier }</span>
		)

		if (this.props.user.tier + 2 <= perk.tier) {
			var displayItemClass = " outRangeTier"
			var src = require("tiers/lock.png");
			var lockTip = "You must be level " + (perk.tier + 1) + " to buy this perk.";
			var perkImg = (
				<img src={ src } className="lockImg" data-tip={ lockTip } />
			)
		} else if (this.props.user.tier + 1 <= perk.tier) {
			var displayItemClass = " inRangeTier"
			var lockTip = "You must be level " + (perk.tier + 1) + " to buy this perk.";
			var perkImg = (
				<img src={ perkPath } className="patchThumbnail" data-tip={ lockTip } />
			)
		} else {
			var displayItemClass = " sameTier"
			var perkImg = (
				<img src={ perkPath } className="patchThumbnail" />
			)
		}

		if (this.state.inConfirm) {
			displayItemClass += " inConfirm"
		}

		if (perk.perk_type == OwlShopDisplay.TITLES) {
			var perkTitle = perk.name;
			var perkDisplay = (
				<div>
					<p className="title">{ perkTitle }</p>
				</div>	
			)
			var perkKey = Math.random();
			var titleClass = " titleClass";
		} else {
			var perkDisplay = (
				<div>
					{ perkImg }
					<p className="title">{ perkTitle }</p>
				</div>	
			)
		}
		
		if (perk == this.props.previewItem) {
			var selectedClass = "selectedPatch "
		}

		if (!perk.owned) {
			if (this.props.user.tier + 2 <= perk.tier) {
				var purchase = "";
			} else {
				var purchase = (
					<CoinDisplay coins={ perk.price } height={ 20 } />
				);
			}
		} else {
			var purchase = (
				<span className="statusText">
					<Glyphicon icon="ok" /> owned
				</span>
			)
		}

		var tier = (<img src={ Tiers.getIcon(perk.tier) } className="tierImg" />)

		var patchValueContainer = (
			<div className="patchValueContainer">
				{ purchase }			
				{ tier }
			</div>
		)

		return (
			<a key={ perkKey } className={ "displayItem " + selectedClass + titleClass + displayItemClass } href="#"
				onClick={ this.buildSelectItemF(perk) }>
				{ perkDisplay }
				{ patchValueContainer }
			</a>
		);
	}

	renderControls() {
		var paired = this.getAlternatePatchTypes();
		if (paired.length > 0) {
			var altOps = [];
			_.each(paired, function(op, index) {
				if (index > 0) {
					altOps.push(
						<span className="verticalDivider" key={ "divider" + index } />
					);
				}

				altOps.push(
					<a href="#" onClick={ this.buildOnClickAlternateF(op.value) } key={ op.value }
						className={ this.getEquipPatchType() == op.value ? "selected" : "" }>
						{ op.text }
					</a>
				);
			}.bind(this));


			var alternates = (
				<div className="alternatePatchTypes">
					{ altOps }
				</div>
			);
		} else {
			var paired = this.getAlternatePerkTypes();
			if (paired.length > 0) {
				var altOps = [];
				_.each(paired, function(op, index) {
					if (index > 0) {
						altOps.push(
							<span className="verticalDivider" key={ "divider" + index } />
						);
					}

					altOps.push(
						<a href="#" onClick={ this.buildOnClickAlternateFPerk(op.value) } key={ op.value }
							className={ this.getEquipPatchType() == op.value ? "selected" : "" }>
							{ op.text }
						</a>
					);
				}.bind(this));


				var alternates = (
					<div className="alternatePatchTypes">
						{ altOps }
					</div>
				);
			}
		}

		return (
			<div className="displayControls text-center">
				{ alternates }
				<button className="btn btn-link arrow" disabled={ !this.canShiftLeft() }
					onClick={ this.shiftLeft }>
					<Glyphicon icon="arrow-left" />
				</button>
				<button className="btn btn-link arrow" disabled={ !this.canShiftRight() }
					onClick={ this.shiftRight }>
					<Glyphicon icon="arrow-right" />
				</button>
			</div>
		);
	}

	getSoundPerks() {
		var sound_sources = []
		if (this.props.itemType == OwlShopDisplay.BACKGROUND_SOUNDS) {
			var dir = "background/"	
		} else {
			var dir = "owl_hoots/"
		}
		this.props.items.forEach(function(item){
			sound_sources.push({"ref":item.name,"path":dir + item.name,"play":false})
		})
		if (window.wrL2eSound) {
			window.wrL2eSound.addSource(sound_sources,"shop")			
		}
	}

	// gets the page on which tier items begin
	getTierPage(items, userTier) {
		var tierIndex = items.findIndex(item => {
			return item.tier == userTier})
		// divides index of first item within tier by the max num items per page
		var tierPage = Math.floor(Math.max(0, tierIndex)/OwlShopDisplay.MAX_ITEMS)
		return tierPage
	}

	sortItemsByTier(items) {
		var items = _.sortBy(items, function(item) {
			if (item.patch_type) {
				var onSale = ShopSales.isOnSale(item.origin_patch_type, item.name) ? "0sale" : "1sale";
			} else {
				onSale = "1sale";
			}
			var tier = item.tier || 0;
			var price = item.price || 0;
			return onSale + " " + tier + " " + price;
		});
		return items
	}

	render() {
		var items = this.props.items.slice(this.state.itemOffset,
			this.state.itemOffset + OwlShopDisplay.MAX_ITEMS);

		if (this.props.mode == "dressing" && this.props.items.length == 0) {
			var displayItems = (
				<div className="emptyMessage">
					You don't own any items of this type yet!
				</div>
			)
		} else {
			if (this.props.isPatch) {
				var displayItems = _.map(items, function(item) {
					return this.renderPatchItem(item);
				}.bind(this));
			} else {
				var displayItems = _.map(items, function(item) {
					return this.renderPerkItem(item);
				}.bind(this));
			}
		}
		

		if (this.props.previewItem) {
			var item = this.props.previewItem;
			var userCoins = this.props.user.coins;
			if (this.props.mode != "dressing") {
				var item_description = item.description
			}

			if (item.owned) {
				
				if (this.props.itemType == OwlShopDisplay.BACKGROUNDS || this.props.itemType == OwlShopDisplay.TITLES || this.props.itemType == OwlShopDisplay.GREETINGS || this.props.itemType == OwlShopDisplay.OWL_HOOTS || this.props.itemType == OwlShopDisplay.BACKGROUND_SOUNDS || this.props.itemType == OwlShopDisplay.HOUSES) {
					var previewControl = (
						<div className="previewControl">
							<LoadingButton className="btn buttonSuccess" loading={ this.props.loading }
								onClick={ this.onPurchase } text="Save" />
							<button className="btn btn-link" onClick={ this.onRemove }>
								Remove
							</button>
						</div>
					)
				} else {
					if (item.animation && !item.has_animation) {
						var upgrade = (
							<div>
								<LoadingButton className="btn buttonSuccess" loading={ this.props.loading }
									onClick={ this.confirmPurchase } text="Upgrade!" />
							</div>
						)
						
						item_description = (
							<div> 
								<CoinDisplay coins={ 250 } height={ 16 } />
								<p className="upgradeText">Upgrade and watch this {item.title} come to life! </p> 
							</div>
						)
					}
					var previewControl = (
						<div className="previewControl">
							{upgrade}
							<button className="btn btn-link" onClick={ this.onRemove }>
								Remove
							</button><br />
						</div>
					)
				}
			} else if (this.props.user.tier >= item.tier) {

				if (item.price <= userCoins) {
					var previewControl = (
						<div className="previewControl">
							<LoadingButton className="btn buttonSuccess" loading={ this.props.loading }
								onClick={ this.confirmPurchase } text="Buy it" /><br />
						</div>
					)
				} else {
					var previewControl = (
						<div className="previewControl">
							<p className="statusText">You can't afford this item yet.</p>
						</div>
					)
				}
			} else {
				var previewControl = (
					<div className="previewControl">
						<p className="statusText">Available at the { Tiers.getName(item.tier) } level.</p>
					</div>
				)
			}

			if (this.props.itemType == OwlShopDisplay.GREETINGS) {
				var previewAnimation = (
					<div className="previewControl">
					<button className="btn btn-link" onClick={ () => this.previewAnimation(this.props.previewItem.name) }>
						Preview
					</button>
					</div>
				)
			}

			if (this.props.user.tier + 2 <= item.tier) {
				var previewDetailsClass = " outRangeTier"
			} else if (this.props.user.tier + 1 <= item.tier) {
				var previewDetailsClass = " inRangeTier"
			} else {
				var previewDetailsClass = " sameTier"
			}

			var previewDetails = (
				<CSSTransition classNames="expand" timeout={{ enter: 300, exit: 300 }} >

					<div className={ "previewDetails" + previewDetailsClass} key={ this.props.previewItem.name }>
						<div className="previewDesc">
							<p><strong>{ item.title }</strong></p>
							<p className={"itemDescription"}>{ item_description }</p>
							{ previewAnimation }
						</div>
						{ previewControl }
					</div>

				</CSSTransition>
				
			);	
			
			var confirmPurchase = (
				<PurchaseModal
					ref = "purchaseModal"
					student = {this.props.user}
					previewItem = {this.props.previewItem}
					isPatch = {this.props.isPatch}
					renderPatchItem = {this.renderPatchItem}
					renderPerkItem = {this.renderPerkItem}
					onPurchase = {this.onPurchase}
					checkConfirm = {this.checkConfirm.bind(this)}
				/>
			);
		}

		return (
			<div className="owlShopDisplay">
				{ this.renderControls() }
				<TransitionGroup>
					{ previewDetails }
				</TransitionGroup>
				{ displayItems }
				{ confirmPurchase }
			</div>
		);
	}

	componentWillUnmount() {
		if (window.wrL2eSound) {
			window.wrL2eSound.removeSources('shop')			
		}
	}
};

OwlShopDisplay.MAX_ITEMS = 8;
OwlShopDisplay.BACKGROUNDS = "backgrounds";
OwlShopDisplay.TITLES = "titles";
OwlShopDisplay.HOUSES = "houses";
OwlShopDisplay.GREETINGS = "greetings";
OwlShopDisplay.OWL_HOOTS = "owl_hoots";
OwlShopDisplay.BACKGROUND_SOUNDS = "background_sounds";
OwlShopDisplay.SOFAS = "sofas"
OwlShopDisplay.BOOKSHELVES = "bookshelves"
OwlShopDisplay.WALL_ITEMS = "wall_items"
OwlShopDisplay.WALL_ITEMS_2 = "wall_items2"
OwlShopDisplay.FLOOR_ITEMS = "floor_items"
OwlShopDisplay.FLOOR_ITEMS_2 = "floor_items2"

OwlShopDisplay.FURNITURES = [OwlShopDisplay.SOFAS, OwlShopDisplay.BOOKSHELVES, OwlShopDisplay.WALL_ITEMS, OwlShopDisplay.WALL_ITEMS_2, OwlShopDisplay.FLOOR_ITEMS, OwlShopDisplay.FLOOR_ITEMS_2]
OwlShopDisplay.propTypes = StrictPropTypes({
	items: PropTypes.array.isRequired,
	previewItem: PropTypes.object,
	itemType: PropTypes.string,
	isPatch: PropTypes.bool,
	user: PropTypes.object,

	selectItem: PropTypes.func.isRequired,
	purchaseItem: PropTypes.func,
	removeItem: PropTypes.func,

	loading: PropTypes.bool,
	hideAlternates: PropTypes.bool,

	buildItemTypeSelectF: PropTypes.func,
	beginAtTier: PropTypes.bool,
	previewAnimation: PropTypes.func,

	mode: PropTypes.string
});

module.exports = OwlShopDisplay;


// WEBPACK FOOTER //
// ./modules/components/avatars/OwlShopDisplay.js